import React from "react";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { Tooltip as MatToolTip } from "@mui/material";
import qodexLogoFull from '../../assets/logos/logo_small.png';

const BlankScreen = ({ user, onSuggestionClick = () => { } }) => {
    let suggestions = [
        {
            title: "Unit Test",
            description: "Generate endpoint-level unit tests for each route in the current API collection. For every endpoint, include: \n 1. One positive test case with valid inputs \n 2. One negative test case with invalid or missing parameters \n 3. One boundary-value case (e.g., max-length strings or edge-case numbers)"
        },
        {
            title: "Functional Test",
            description: "Write end-to-end functional tests that simulate real user flows across the API. Automatically generate any prerequisite data and ensure proper cleanup post-execution."
        },
        {
            title: "OWASP Tests",
            description: "Generate security test cases that cover the OWASP API Top 10 vulnerabilities—including, but not limited to: Broken Authentication, Broken Object Level Authorization, Injection (SQL, NoSQL, Command), Security Misconfiguration, Sensitive Data Exposure, Broken Access Control, Cross-Site Scripting (XSS), and other API-specific risks. Each test should attempt a realistic exploit and verify the API's defensive response."
        }
    ]

    return (
        <>
            <div className="flex justify-start mb-3">
                <Avatar
                    icon={<img src={qodexLogoFull} alt="Qodex AI Assistant" className="object-cover w-full h-full" />}
                    className="mr-3 bg-white text-[var(--text-primary)] shadow-lg"
                    style={{ width: "2.5rem", height: "2.5rem" }}
                    shape="circle"
                />
                <div className="group max-w-[85%] shadow-xl transition-all duration-200 rounded-md px-2 py-1 bg-[var(--agent-msg-bg)] text-[var(--text-primary)] relative mb-4">
                    <div className="m-0">
                        <p className="mb-2">Hi {user && user?.name ? user.name : 'Qodex User'},</p>
                        <p>What would you like to test today?</p>
                    </div>
                    <div className="my-2">
                        <hr className="border-[var(--borderColor)]" />
                        <div className="flex flex-wrap gap-2 w-full">
                            {suggestions.map((suggestion, index) => {
                                return (
                                    <MatToolTip title="Select Suggestion" placement="bottom">
                                        <Button
                                            key={index}
                                            onClick={() => onSuggestionClick(suggestion.description)}
                                            className="bg-[var(--agent-option)] hover:bg-[var(--hover-bg)] px-3 py-1 !rounded-full shadow-none transition-all w-fit border-none font-normal text-[var(--text-primary)]"
                                        >
                                            <span className="text-sm">{suggestion.title}</span>
                                        </Button>
                                    </MatToolTip>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default BlankScreen;